// export const BASE_API = "http://127.0.0.1:8000/api";
export const BASE_API = "https://api.ha-rue.com/api";

export const BASE_URL = "https://www.ha-rue.com";
export const BASE_COOKIE_URL = ".ha-rue.com";

export const PATH_TO_SKIP_PRIVACY_CONSENT = ["/privacy"];
